export enum SurveyError {
  EXPIRED = 'survey_expired_error',
  COMPLETED = 'survey_completed_error'
}
